import { addonsText } from "@/utils/canteenPayment";

// Skraćenica za ključeve ekrana "Isporuka narudžbi v4": tx("sig.ready") → $t("canteenV4.sig.ready").
export default {
  methods: {
    tx(key, params) {
      return this.$t("canteenV4." + key, params);
    },
    // izabrana jela paketa uz stavku: "Šakšuka, 2× Pileća supa" (prazno kad stavka nije paket)
    adds(item) {
      return addonsText(item && item.addons, (s) => this.toLatin(s));
    },
  },
};
